import React, { useEffect } from "react";
import { ContentSection, createListTableColumns, ListTable, Stack, Text } from "sprint-common-web";

import { OrderProxiesListingItem } from "./OrderProxiesListingItem";
import { useOrderProxiesSection } from "./useOrderProxiesSection";
import { useOrderProxiesSectionFilters } from "./useOrderProxiesSectionFilters";

interface OrderProxiesSectionProps {
    height: number;
}

export const OrderProxiesSection: React.VFC<OrderProxiesSectionProps> = ({ height }: OrderProxiesSectionProps) => {
    const { filters, setSort } = useOrderProxiesSectionFilters();
    const { items, isLoading, filterData } = useOrderProxiesSection();

    useEffect(() => {
        filterData(filters);
    }, [filters]);

    const columns = createListTableColumns<OrderProxiesListingItem>([
        {
            type: "basic",
            key: "filePath",
            name: "File Path",
            minWidth: 400,
            maxWidth: 800,
            isSortable: true,
            onRender: (item) => (
                <Text tooltip={item?.filePath} variant="small">
                    {item?.filePath}
                </Text>
            )
        },
        {
            type: "basic",
            key: "language",
            name: "Language",
            minWidth: 140,
            maxWidth: 180
        },
        {
            type: "basic",
            key: "proxyType",
            name: "Type",
            minWidth: 60,
            maxWidth: 70,
            isResizable: false
        }
    ]);

    return (
        <ContentSection header="Proxies" style={{ height }} testId={"proxies-section"}>
            <Stack styles={{ root: { overflowY: "auto", height: 400 } }}>
                <ListTable
                    columns={columns}
                    items={items}
                    isLoading={isLoading}
                    shimmerLines={7}
                    onSortChange={setSort}
                    sort={{ by: filters.sortBy, order: filters.sortOrder }}
                    noItemsMessage="No proxies"
                />
            </Stack>
        </ContentSection>
    );
};
